export const SCHEDULES_API_URL = 'api/schedules';